export const DEFAULT_PLACEHOLDERS = [
  {
    name: "First Name",
    type: "text",
  },
  {
    name: "Last Name",
    type: "text",
  },
  {
    name: "Full Name",
    type: "text",
  },
  {
    name: "Company",
    type: "text",
  },

  {
    name: "Address 1",
    type: "text",
  },
  {
    name: "City",
    type: "text",
  },
  {
    name: "State",
    type: "text",
  },
  {
    name: "Zip",
    type: "text",
  },
  {
    name: "Coupon 1",
    type: "text",
  },
  {
    name: "Coupon 2",
    type: "text",
  },
];
